import {
  ListItemIcon,
  ListItem,
  ListItemButton,
  Typography,
  ImageListItem,
  Avatar,
  IconButton,
} from "@mui/material";

import { Constants } from "./Constants";
import emailsvg from "../../static/SVG/email.svg";
import locksvg from "../../static/SVG/password.svg";
import edit from "../../static/SVG/edit.svg";
import homeicon1 from "../../static/SVG/home.svg";
import user from "../../static/SVG/user.svg";
import reportissue from "../../static/SVG/reportissue.svg";
import cincIcon from "../../static/SVG/calender.svg";
import eye from "../../static/SVG/eye.svg";
import DeleteIcon from "../../static/SVG/delete.svg";
import switchon from "../../static/SVG/switchon.svg";
import switchoff from "../../static/SVG/switchoff.svg";
import cincologonew from "../../static/SVG/cinco.logo.svg";
import Gallery from "../../static/SVG/Gallery.svg";
import filter from "../../static/SVG/filter.svg";
import camera from "../../static/SVG/camera.svg";
import eyeOff from "../../static/SVG/eye-off.svg";
import map from "../../static/SVG/map.svg";

import arrow from "../../static/SVG/layer1.svg";
import clock from "../../static/SVG/clock1.svg";
import calender from "../../static/SVG/calendar1.svg";
import times from "../../static/SVG/timesIcon.svg";
import search from "../../static/SVG/search.svg";
import circleClose from "../../static/SVG/circleClose.svg";
import carrotRight from "../../static/SVG/carrotRight.svg";
import { RoutesPath } from "../../routes/route-path";
import uploadIcon from "../../static/SVG/upload.svg";
import openEye from "../../static/SVG/openeye.svg";
export const Logo = (props) => {
  return (
    <>
      <Typography
        noWrap
        component="div"
        style={props.styles}
        onClick={() => props.route.router(RoutesPath.HOME)}
      >
        <ImageListItem fullWidth style={props.styles}>
          <img
            fullWidth
            // style={styless.transform_0}
            src={cincologonew}
          />
        </ImageListItem>
      </Typography>
    </>
  );
};

export const Home = (props) => {
  return (
    <>
      <ListItem
        //disablePadding
        style={props.styles}
      >
        <ListItemButton onClick={() => props.router(RoutesPath.HOME)}>
          <ListItemIcon>
            <HomeIcon1
              color={Constants.COLOR_BLACK}
              fontSize={Constants.FONT_SIZE_MEDIUM}
            />
          </ListItemIcon>
        </ListItemButton>
      </ListItem>
    </>
  );
};

export const User = (props) => {
  return (
    <>
      <ListItem
        //disablePadding
        style={props.styles}
      >
        <ListItemButton onClick={() => props.router(RoutesPath.USER)}>
          <ListItemIcon>
            <UserIcon
              color={Constants.COLOR_BLACK}
              fontSize={Constants.FONT_SIZE_MEDIUM}
            />
          </ListItemIcon>
        </ListItemButton>
      </ListItem>
    </>
  );
};

export const Event = (props) => {
  return (
    <>
      <ListItem
        //disablePadding
        style={props.styles}
      >
        <ListItemButton onClick={() => props.router(RoutesPath.EVENT)}>
          <ListItemIcon>
            <CincIcon
              color={Constants.COLOR_BLACK}
              fontSize={Constants.FONT_SIZE_MEDIUM}
            />
          </ListItemIcon>
        </ListItemButton>
      </ListItem>
    </>
  );
};

export const Report = (props) => {
  return (
    <>
      <ListItem
        //disablePadding
        style={props.styles}
      >
        <ListItemButton onClick={() => props.router(RoutesPath.REPORT_ISSUE)}>
          <ListItemIcon>
            <IssueIcon
              color={Constants.COLOR_BLACK}
              fontSize={Constants.FONT_SIZE_MEDIUM}
            />
          </ListItemIcon>
        </ListItemButton>
      </ListItem>
    </>
  );
};
export const GallerySideIcon = (props) => {
  return (
    <>
      <ListItem
        // disablePadding
        style={{
          ml: 0.5,
          textAlign: "center",
          "&:hover": {
            cursor: "pointer",
          },
          justifyContent: "center",
        }}
      >
        <ListItemButton onClick={() => props.router(RoutesPath.REPORT_ISSUE)}>
          <ListItemIcon>
            <GalleryIcon
              color={Constants.COLOR_BLACK}
              fontSize={Constants.FONT_SIZE_MEDIUM}
            />
          </ListItemIcon>
        </ListItemButton>
      </ListItem>
    </>
  );
};
export const ListActionsIcons = (props) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
      {/* <Grid
        item
        md={6}
        sm={6}
        xs={12}> */}
      <IconButton onClick={props.viewById} style={{ background: "#fff" }}>
        <EyeIcon />
      </IconButton>
      {props.editById ? (
        <IconButton onClick={props.editById} style={{ background: "#fff" }}>
          <EditIcon />
        </IconButton>
      ) : (
        ""
      )}
      {props.deleteById ? (
        <IconButton onClick={props.deleteById} style={{ background: "#fff" }}>
          <DeleteIcon1 />
        </IconButton>
      ) : (
        ""
      )}
      {/* </Grid> */}
    </div>
  );
};

// export default function AuthImage() {
//   return (
//     <>
//       <Grid
//         item
//         xs={6}
//         lg={6}
//         md={6}
//         sm={6}
//         spacing={1}
//         container
//         direction="column"
//         alignItems="center">
//         <ImageListItem fullWidth>
//           <img
//             fullWidth
//             style={{ transform: "translateZ(1)" }}
//             src={LoginImage}
//           />
//         </ImageListItem>
//       </Grid>
//     </>
//   );
// }
export const AvatarImage = (props) => {
  return (
    <>
      <Avatar alt="" src={props.image} style={props.styles} />
    </>
  );
};
export const AvatarImageSquare = (props) => {
  return (
    <>
      <Avatar alt="" src={props.image} style={props.styles} variant="square" />
    </>
  );
};
export const EmailIcon = (props) => {
  return (
    <>
      <img alt="" src={emailsvg} style={props.styles?.icon} />
    </>
  );
};
export const LockIcon = (props) => {
  return (
    <>
      <img alt="" src={locksvg} style={props.styles?.icon} />
    </>
  );
};
export const EditIcon = (props) => {
  return (
    <>
      <img alt="" src={edit} style={props.styles} />
    </>
  );
};
export const EditIconbadge = (props) => {
  return (
    <>
      <img alt="" src={edit} style={props.styles} />
    </>
  );
};
export const HomeIcon1 = (props) => {
  return (
    <>
      <img alt="" src={homeicon1} style={props.styles} />
    </>
  );
};
export const UserIcon = (props) => {
  return (
    <>
      <img alt="" src={user} style={props.styles} />
    </>
  );
};
export const IssueIcon = (props) => {
  return (
    <>
      <img alt="" src={reportissue} style={props.styles} />
    </>
  );
};
export const CincIcon = (props) => {
  return (
    <>
      <img alt="" src={cincIcon} style={props.styles} />
    </>
  );
};
export const EyeIcon = (props) => {
  return (
    <>
      <img alt="" src={eye} style={props.styles} />
    </>
  );
};
export const DeleteIcon1 = (props) => {
  return (
    <>
      <img alt="" src={DeleteIcon} style={props.styles} />
    </>
  );
};
export const SwitchONIcon = (props) => {
  return (
    <>
      <img alt="" src={switchon} style={props.styles} />
    </>
  );
};
export const SwitchOFFIcon = (props) => {
  return (
    <>
      <img alt="" src={switchoff} style={props.styles} />
    </>
  );
};
export const GalleryIcon = (props) => {
  return (
    <>
      <img alt="" src={Gallery} style={props.styles} />
    </>
  );
};
export const FilterIcon = (props) => {
  return (
    <>
      <img alt="" src={filter} style={props.styles} />
    </>
  );
};
export const MapIcon = (props) => {
  return (
    <>
      <img alt="" src={map} style={props.styles} />
    </>
  );
};

export const ArrowDownIcon = (props) => {
  return (
    <>
      <img alt="" src={arrow} style={props.styles} {...props} />
    </>
  );
};
export const ClockIcon = (props) => {
  return (
    <>
      <img alt="" src={clock} style={props.styles} />
    </>
  );
};
export const CalendarIcon = (props) => {
  return (
    <>
      <img alt="" src={calender} style={props.styles} />
    </>
  );
};
export const TimesIcon = (props) => {
  return (
    <>
      <img alt="" src={times} style={props.styles} />
    </>
  );
};
export const SearchIcon = (props) => {
  return (
    <>
      <img alt="" src={search} style={props.styles} />
    </>
  );
};
export const CircleCloseIcon = (props) => {
  return (
    <>
      <img alt="" src={circleClose} style={props.styles} />
    </>
  );
};
export const UploadIcon = (props) => {
  return (
    <>
      <img alt="" src={uploadIcon} style={props.styles} />
    </>
  );
};

export const CameraIcon = (props) => {
  return (
    <>
      <img alt="" src={camera} style={props.styles} />
    </>
  );
};
export const EyeOffIcon = (props) => {
  return (
    <>
      <img alt="" src={eyeOff} style={props.styles} />
    </>
  );
};
export const EyeOpenIcon = (props) => {
  return (
    <>
      <img alt="" src={openEye} style={props.styles} />
    </>
  );
};
export const CarrotRightIcon = (props) => {
  return (
    <>
      <img alt="" src={carrotRight} style={props.styles} />
    </>
  );
};
